import NewslatterForm from "./newslatter-form";
export default NewslatterForm;
